/*
 * «Доступ в кабинет» на экране сотрудников и окно приглашения (Б9).
 * Макета у окна нет — сетка и размеры те же, что у соседних окон журнала и карточек списка.
 */

/*
 * Панель стоит в левой колонке ПОСЛЕ списка сотрудников, а не внутри него, поэтому
 * боковые отступы у неё свои — те же, что у списка (--space-4). Без них карточка
 * упиралась рамкой в края колонки, а на телефоне — в края экрана, и выбивалась
 * из строя строк над ней.
 */
.panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  margin: var(--space-1) var(--space-4) var(--space-3);
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.head {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: space-between;
}

.title {
  font-weight: var(--font-weight-semibold);
}

.hint {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.row {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid var(--grid-line-minor);
}

.rowMain {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.contact {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.error {
  font-size: var(--font-size-sm);
  color: var(--danger);
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(420px, 100%);
}

.branches {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0;
  margin: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: 4px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

.linkLabel {
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-faint);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.link {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  font-family: var(--font-mono, monospace);
  font-size: var(--font-size-sm);
  background: var(--bg-workspace);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
}

.caption {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: 1.45;
  color: var(--text-secondary);
}

.buttons {
  display: flex;
  gap: var(--space-2);
  justify-content: flex-end;
}

.retry {
  padding: 0;
  font: inherit;
  color: var(--text-brand);
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}

/*
 * Строка человека с доступом (4-Б8, members-list.tsx) — та же строка, что у приглашения,
 * но целиком нажимается: открывает карточку 4-Б10. Кнопка, а не div с обработчиком, —
 * чтобы карточка открывалась и с клавиатуры.
 */
.memberButton {
  display: flex;
  flex: 1;
  gap: var(--space-2);
  align-items: center;
  min-width: 0;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
}

.memberButton:hover .contact {
  text-decoration: underline;
}

.toggle {
  align-self: flex-start;
  font-size: var(--font-size-sm);
}
